(function () {
  var roots = document.querySelectorAll('[data-tn-bestsellers]');
  if (!roots.length) return;

  roots.forEach(function(root){
    var container = root.querySelector('.tn-bestsellers__container');
    var track     = root.querySelector('.tn-bestsellers__track');
    var cards     = Array.from(root.querySelectorAll('.tn-bestsellers__card'));
    var btnLeft   = root.querySelector('.tn-bestsellers__nav--left');
    var btnRight  = root.querySelector('.tn-bestsellers__nav--right');
    if (!container || !track || cards.length === 0 || !btnLeft || !btnRight) return;

    function pl() {
      return parseFloat(getComputedStyle(track).paddingLeft) || 0;
    }
    function hasOverflowX(el){
      return el.scrollWidth - el.clientWidth > 1;
    }
    function leftForCard(el){
      return Math.max(0, el.offsetLeft - pl());
    }
    function currentIndex(){
      var sl = track.scrollLeft, idx = 0, best = Infinity;
      cards.forEach(function(el, i){
        var target = leftForCard(el), delta = Math.abs(target - sl);
        if (delta < best) { best = delta; idx = i; }
      });
      return idx;
    }
    function scrollToIndex(i){
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: leftForCard(cards[i]), behavior: 'smooth' });
    }
    function nextIndex(){
      var sl = track.scrollLeft + 1;
      for (var j = 0; j < cards.length; j++){
        var t = leftForCard(cards[j]);
        if (t > sl) return j;
      }
      return cards.length - 1;
    }
    function prevIndex(){
      var sl = track.scrollLeft - 1;
      for (var j = cards.length - 1; j >= 0; j--){
        var t = leftForCard(cards[j]);
        if (t < sl) return j;
      }
      return 0;
    }
    function atStart(){ return track.scrollLeft <= 1; }
    function atEnd(){ return track.scrollLeft >= (track.scrollWidth - track.clientWidth - 1); }

    function updateArrows(){
      var scrollable = hasOverflowX(track);
      root.classList.toggle('tn-has-scroll', scrollable);
      btnLeft.classList.toggle('is-disabled',  !scrollable || atStart());
      btnRight.classList.toggle('is-disabled', !scrollable || atEnd());
    }

    btnRight.addEventListener('click', function(){ scrollToIndex(nextIndex()); });
    btnLeft.addEventListener('click',  function(){ scrollToIndex(prevIndex()); });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });
    Array.from(track.querySelectorAll('img')).forEach(function(img){
      img.addEventListener('load', updateArrows, { once: true });
    });

    updateArrows();
  });
})();